import { render, staticRenderFns } from "./EcosystemPlatformSelect.vue?vue&type=template&id=fb936c80"
import script from "./EcosystemPlatformSelect.vue?vue&type=script&lang=js"
export * from "./EcosystemPlatformSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports